import { WEBCHAT_DUPLICATED_PHONE_MESSAGES } from 'modules/webchat/domain/constants';
import { HTTPError } from 'shared/domain/errors';

const normalize = (text: string) => text.trim().toLowerCase();

/**
 * Reconhece a recusa do PUT /clientes por celular já cadastrado. Acontece
 * quando a identificação disse 'novo' mas o celular existe com outro formato
 * no cadastro, ou quando o GET do Vectis falhou e respondeu 204.
 */
export default function isDuplicatedPhoneError(error: unknown): boolean {
  if (!(error instanceof HTTPError) || !error.message) return false;

  const message = normalize(error.message);

  return WEBCHAT_DUPLICATED_PHONE_MESSAGES.some(duplicatedMessage =>
    message.includes(normalize(duplicatedMessage)),
  );
}
